export default __webpack_public_path__ + "static/rayban-e00752ab4d3edffacd498d53aefa22dc.png";